import { render } from "./Badge7.vue?vue&type=template&id=e52627a0&scoped=true"
import script from "./Badge7.vue?vue&type=script&lang=js"
export * from "./Badge7.vue?vue&type=script&lang=js"

import "./Badge7.vue?vue&type=style&index=0&id=e52627a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e52627a0"]])

export default __exports__